import React from 'react';
import { Link } from 'react-router-dom';

const InfoSection = () => {
  return (
    <div>
      <section className="h-[300px]  pt-6 mb-10 px-3 lg:px-0">
        <div className="max-w-screen-lg mx-auto bg-blue-700 text-center text-white flex flex-col sm:flex-row items-center gap-4 p-6 sm:h-[250px] rounded-lg ">
          {/* Logo and Divider */}
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:w-auto w-full">
            <div className="flex items-center">
              <img
                src="logo.png"
                alt="ApplicationUni Logo"
                className="h-10 -ml-[50px] lg:ml-0"
              />
              <h1 className="text-2xl font-bold ml-3">ApplicationUni</h1>
            </div>
            <div className="hidden sm:block h-full w-px bg-white mx-4"></div>
          </div>

          {/* Text Section */}
          <div className=" text-left text-lg lg:text-3xl font-bold flex-1 mt-4 sm:mt-0 mr-[15px] ">
            AI powered eligibility check
            <br />  for international Universities

          </div>

          {/* Button Section */}
          <div className="mt-6 sm:mt-0 sm:ml-0 mr-[116px] lg:mr-0">
            <Link to="/eligibility">
              <button className="bg-white text-xs lg:text-base rounded-lg px-3 lg:px-6  py-2 shadow hover:bg-gray-100 transition font-semibold text-blue-600 w-full sm:w-auto flex items-center gap-2 ">
                Check Eligibility
                <img src="https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/google-gemini-icon.png" alt="" className=' h-2 lg:h-3 mb-2 lg:mb-2 -ml-2' />
              </button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InfoSection;
